import { render, staticRenderFns } from "./grouplist.vue?vue&type=template&id=72d8e5a0&scoped=true&"
import script from "./grouplist.vue?vue&type=script&lang=js&"
export * from "./grouplist.vue?vue&type=script&lang=js&"
import style0 from "./grouplist.vue?vue&type=style&index=0&id=72d8e5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8e5a0",
  null
  
)

export default component.exports